var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"none","d":"M16.879 22.273h-2.587v-6.137H13V14.02h1.292v-1.27c0-1.725.73-2.751 2.804-2.751h1.725v2.115h-1.078c-.807 0-.86.296-.86.847l-.004 1.059h1.954l-.228 2.115h-1.726v6.137","key":0}),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},React.createElement("circle",{"cx":"16","cy":"16","r":"15.5"}))]);
}

FacebookInline.defaultProps = {"width":"32","height":"32","fill":"#97979D","stroke":"#97979D"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
